import { render, staticRenderFns } from "./SimpleMarker.vue?vue&type=template&id=cd61a64a&scoped=true&"
import script from "./SimpleMarker.vue?vue&type=script&lang=js&"
export * from "./SimpleMarker.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMarker.vue?vue&type=style&index=0&id=cd61a64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd61a64a",
  null
  
)

export default component.exports